import { getGroups } from "@/company/groups/services/groups-service";
import { GetGroupsParams, GetGroupsResponse } from "@/company/groups/types";
import { useAuth } from "@/core/components/auth/store/auth";
import { useDebounce } from "@/core/utils/debounce";
import { useQuery } from "@tanstack/react-query";
import { useMemo, useState } from "react";

const useGroupInput = () => {
  const {
    userInfo: { user },
  } = useAuth();
  const [searchParams, setSearchParams] = useState<GetGroupsParams>({
    companyId: user.leagues_id[0],
    page: 1,
    limit: 10,
    search: "",
    filters: [],
  });

  const debouncedSearch = useDebounce(searchParams.search, 300);
  const debouncedParams = useMemo(() => {
    // Necessário mudar a API para respeitar o search
    if (debouncedSearch) {
      searchParams.filters = [
        ...(searchParams.filters || []),
        {
          id: "name",
          value: debouncedSearch,
        },
      ];
    } else {
      searchParams.filters = searchParams.filters?.filter(
        (filter) => filter.id !== "name",
      );
    }
    // Necessário mudar a API para respeitar o search

    const params = {
      ...searchParams,
      search: debouncedSearch,
    };

    return params;
  }, [searchParams, debouncedSearch]);

  const {
    data: response,
    error,
    isLoading,
  } = useQuery<GetGroupsResponse>({
    queryKey: ["group-input", debouncedParams],
    queryFn: async ({ signal }) => await getGroups(debouncedParams, signal),
  });

  const data = useMemo(() => response?.data || [], [response]);
  const pageCount = useMemo(() => response?.totalPages || 1, [response]);

  return {
    data,
    pageCount,
    error,
    isLoading,
    searchParams,
    setSearchParams,
  };
};

export { useGroupInput };
